module.exports = __webpack_public_path__ + "static/media/s_13.050696a5.mp3";